import type { BrowserCapabilityWarning } from "../core/types";

// Return a small set of user-facing warnings about browser print limits so the
// UI can explain why preview and final print output may still differ slightly.
export function getBrowserCapabilityWarnings(userAgent = globalThis.navigator?.userAgent ?? ""): BrowserCapabilityWarning[] {
  const warnings: BrowserCapabilityWarning[] = [
    {
      code: "page-size-support",
      message: "Page size and margin control depend on browser support for @page and print dialog settings."
    },
    {
      code: "background-printing",
      message: "Background colors and images may require the user to enable browser print background options."
    }
  ];

  if (!/(Chrome|Firefox|Safari|Edg)\//.test(userAgent)) {
    warnings.push({
      code: "browser-compat",
      message: "This browser is not part of the primary compatibility matrix for preview and print rendering."
    });
  }

  return warnings;
}

export function canUseDom(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
